import {
  IS_AUTH,
  ERROR_AUTH,
  USER_AUTH,
  FORGOT_PASSWORD,
  RESET_PASSWORD,
  PUT_USER_AUTH,
  LOGIN,
  MESSAGE_AUTH,
  ERROR_LOGIN,
  SET_TOAST,
  GET_NOTIFS,
  PUT_NOTIF,
  DELETE_NOTIF
} from "../actions/types";

const initialState = {
  isAuth: false,
  error: null,
  message: null,
  userAuth: null,
  toast: null,
  notifs: null,
  errorLogin: null 
};

export default function authReducer(state = initialState, action) {
  let notifs = state.notifs
  switch (action.type) {
    case PUT_NOTIF:
      let notifIndex = state.notifs.findIndex(n => n._id === action?.payload?._id)
      notifs[notifIndex] = action.payload
      return {...state , notifs: notifs }
    case DELETE_NOTIF:
        return {...state , notifs: notifs.filter(n => n._id !== action.payload)}
    case GET_NOTIFS:
      return {...state , notifs: action.payload}
    case SET_TOAST:
      return {...state , toast: action.payload}
    case ERROR_LOGIN:
      return {...state , errorLogin: action.payload}
    case MESSAGE_AUTH:
        return {...state , message: action.payload}
    case LOGIN:
      return {...state , isAuth: true }
    case IS_AUTH:
      return {...state , isAuth: action.payload}
    case ERROR_AUTH:
      return {...state , error: action.payload}
    case PUT_USER_AUTH:
      return {...state , userAuth: action.payload , message: "profile updated"}
    case USER_AUTH:
      return {...state , userAuth: action.payload}
    case FORGOT_PASSWORD:
      return {...state , message : { forgot: action.payload.message}}
    case RESET_PASSWORD:
      return {...state , message : { reset: action.payload.message}}
    default:
      return {...state};
  }
}